<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ChuFang`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.18421 15.6428V13.5346C5.18421 13.4563 5.12077 13.3928 5.04251 13.3928C3.08604 13.3928 1.5 11.8068 1.5 9.85035V9.6156C1.5 7.24108 3.66505 5.45547 5.99618 5.90742L7.8765 6.27198C8.00873 6.29762 8.13158 6.19632 8.13158 6.06162V5.55263C8.13158 3.31442 9.94598 1.5 12.1842 1.5" stroke="#333"/><path d="M18.8164 15.6428V13.5346C18.8164 13.4563 18.8798 13.3928 18.9581 13.3928C20.9146 13.3928 22.5006 11.8068 22.5006 9.85035V9.6156C22.5006 7.24108 20.3356 5.45547 18.0044 5.90742L16.1241 6.27198C15.9919 6.29762 15.869 6.19632 15.869 6.06162V5.55263C15.869 3.31442 14.0546 1.5 11.8164 1.5" stroke="#333"/><path d="M19.1583 15.2656H5.21094C4.1754 15.2656 3.33594 16.1051 3.33594 17.1406V17.9978C3.33594 19.0333 4.1754 19.8728 5.21094 19.8728H19.1583C20.1938 19.8728 21.0333 19.0333 21.0333 17.9978V17.1406C21.0333 16.1051 20.1938 15.2656 19.1583 15.2656Z" stroke="#333"/><path d="M11.8145 12.4297V15.0011M14.7637 9.53906V15.0033" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconChuFang',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
